jQuery(function () {
  var search = jQuery('[data-behaviour~="header-search"][data-header-search-expandable="true"]');
  var input = jQuery(search).find("input.search-box");
  var expanded;

  // BEHAVIOUR

  input.on("focus", handleFocus);
  jQuery(document).on("click", handleClick);

  // EVENT HANDLERS

  function handleFocus(event) {
    expand();
  }

  function handleClick(event) {
    if (expanded && isOutsideContainer(event.target)) {
      contract();
    }
  }

  // HELPER FUNCTIONS

  function isOutsideContainer(target) {
    return !jQuery(target).closest(search).length;
  }

  function expand() {
    expanded = true;
    search.addClass("search-active");
    input.addClass("active");
  }

  function contract() {
    expanded = false;
    search.removeClass("search-active");
    input.removeClass("active");
  }
});
